import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { IconComponent } from '../../../../../../ItemsView/IconComponent'
import { SCOPE_OPTIONS } from '../../../../../../ItemsView/typing'
import { messages } from '../messages'

type Props = {
  onEdit: () => void
  onRemove: () => void
}

export function AllItemsRule(props: Props) {
  const { onEdit, onRemove } = props

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconComponent icon={SCOPE_OPTIONS.SKUS} />
      </RuleIcon>

      <RuleDescription>
        <Text variant="body">
          <FormattedMessage {...messages.allItems} />
        </Text>
      </RuleDescription>

      <RuleContent>
        <FormattedMessage
          {...messages.all}
          values={{ tag: (content) => <Tag>{content}</Tag> }}
        />
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
